import http from '@/requests/http'

class CallbackGroup {
  static all (params) {
    return http.post('configuration/inbound/callback-group/index', params)
  }
  static async store (params) {
    return http.post('configuration/inbound/callback-group/store', params)
  }
  static async view (params) {
    return http.post('configuration/inbound/callback-group/view', params)
  }
  static async update (params) {
    return http.post('configuration/inbound/callback-group/update', params)
  }
  static async destroy (params) {
    return http.post('configuration/inbound/callback-group/destroy', params)
  }
}

export default CallbackGroup
